com.inq.flash.client.control.ClickStreamBuilder = function() {};
$hxClasses.registerClass(com.inq.flash.client.control.ClickStreamBuilder,"com.inq.flash.client.control.ClickStreamBuilder");

com.inq.flash.client.control.ClickStreamBuilder.IdentifyPlatform = function () {
	var separator = com.inq.flash.client.control.ClickStreamBuilder.SEP_ATTRIBUTE;
	var platformInfo = com.inq.flash.client.control.ClickStreamBuilder.CSDL_OS + com.inq.utils.Capabilities._getOS() + separator;

	try {
		if (com.inq.flash.client.control.FlashVars.getValue("userAgent") != "") {
			com.inq.flash.client.control.FlashVars.setValue(
				"userAgent",
				js.Lib.window.navigator.userAgent
			);
			platformInfo += com.inq.flash.client.control.ClickStreamBuilder.CSDL_BROWSER
				+ com.inq.utils.Capabilities.extractBrowserNameAndVersion(com.inq.flash.client.control.FlashVars.getValue("userAgent"))
				+ separator + com.inq.flash.client.control.ClickStreamBuilder.CSDL_USERAGENT
				+ StringTools.htmlEscape(com.inq.flash.client.control.FlashVars.getValue("userAgent"))
				+ separator;
			if (!(com.inq.flash.client.control.FlashVars.isContinued()) && com.inq.flash.client.control.FlashPeer.isPersistentWindow()) {
				platformInfo += com.inq.flash.client.control.ClickStreamBuilder.CSDL_CLICK2PER + "YES" + separator;
			}
		}
	} catch (e) {
		if (!js.Boot.__instanceof(e, Error)) {
			throw e;
		}
	}

	haxe.Log.trace(
		"IdentifyPlatform(): exit",
		{
			fileName: "ClickStreamBuilder.js",
			className: "com.inq.flash.client.control.ClickStreamBuilder",
			methodName: "IdentifyPlatform"
		}
	);

	return platformInfo;
};

com.inq.flash.client.control.ClickStreamBuilder.parseClickstreamData = function () {
	/** @type {String} */
	var clickStream = StringTools.urlDecode(com.inq.flash.client.control.FlashVars.getValue("clickStream"));

	return clickStream.split("&");
};

/**
 * parseInitialClickstreamData
 *
 * @public
 * @static
 * @return {string}
 */
com.inq.flash.client.control.ClickStreamBuilder.parseInitialClickstreamData = function () {
	// splits clickstream data
	/** @type {String} */
	var sep = "&";

	// splits attributes in result
	/** @type {String} */
	var sepAttributes = com.inq.flash.client.control.ClickStreamBuilder.SEP_ATTRIBUTE;
	/** @type {String} */
	var csd = "";

	/** @type {object} */
	var clickStream = com.inq.flash.client.control.ClickStreamBuilder.parseClickstreamData();

	for (var i = 0; i < clickStream.length; i++) {
		/** @type {Array} */
		var nVP = clickStream[i].split("=");
		/** @type {String} */
		var name = nVP.shift();
		/** @type {String} */
		var data = nVP.join("=");
		if (data !== "") {
			if (HxOverrides.substr(name, 0, 4) == "data") {
				/** @type {string} */
				var indx = HxOverrides.substr(name, 4, null);
				csd = (csd != "" ? csd + sepAttributes : "") + "_" + name + "=Data[" + indx + "]" + sep + name + "=" + data;
			} else if (name == "markerHistory") {
				csd = (csd != "" ? csd + sepAttributes : "") + com.inq.flash.client.control.ClickStreamBuilder.CSDL_VISITED + data;
			} else if (name == "launchPageMarker") {
				csd = (csd != "" ? csd + sepAttributes : "") + com.inq.flash.client.control.ClickStreamBuilder.CSDL_LAUNCH_PAGE_MARKER + data;
			}
		}
	}

	haxe.Log.trace(
		"ClickStreamBuilder.parseInitialClickstreamData: " + csd,
		{
			fileName: "ClickStreamBuilder.js",
			className: "com.inq.flash.client.control.ClickStreamBuilder",
			methodName: "parseInitialClickstreamData"
		}
	);

	return csd + sepAttributes;
};

/**
 * parseURLfromClickStreamData
 *
 * @public
 * @static
 * @return {string}
 */
com.inq.flash.client.control.ClickStreamBuilder.parseURLfromClickStreamData = function() {
	/** @type {string} */
	var csdURL = "";
	/** @type {object} */
	var clickStream = com.inq.flash.client.control.ClickStreamBuilder.parseClickstreamData();

	for (var i = 0; i < clickStream.length; i++) {
		if (clickStream[i].includes("pageURL")) {
			/** @type {Array} */
			var nVP = clickStream[i].split("=");
			/** @type {String} */
			var name = nVP.shift();
			/** @type {String} */
			var data = nVP.join("=");

			if (data !== "" && name === "pageURL") {
				csdURL = com.inq.flash.client.control.ClickStreamBuilder.CSDL_URL + data;
			}
		}
	}

	return com.inq.flash.client.control.ClickStreamBuilder.SEP_ATTRIBUTE + csdURL;
};

/**
 * parseDFVfromClickStreamData
 *
 * $type TFun([],TInst(String,[]))
 * public static function parseDFVfromClickStreamData():String
 * @public
 * @static
 * @return {string}
 */
com.inq.flash.client.control.ClickStreamBuilder.parseDFVfromClickStreamData = function() {
	/** @type {String} */
	var sep = "&";
	/** @type {String} */
	var csdDFV = "";

	/** @type {object} */
	var clickStream = com.inq.flash.client.control.ClickStreamBuilder.parseClickstreamData();

	for (var i = 0; i < clickStream.length; i++) {
		if (clickStream[i].includes("dfv")) {
			/** @type {Array} */
			var nVP = clickStream[i].split("=");
			/** @type {String} */
			var name = nVP.shift();
			/** @type {String} */
			var data = nVP.join("=");
			if (data !== "" && name == "dfv") {
				csdDFV = (csdDFV != "" ? csdDFV + sep : "") + com.inq.flash.client.control.ClickStreamBuilder.CSDL_DFV + data;
			}
		}
	}

	return com.inq.flash.client.control.ClickStreamBuilder.SEP_ATTRIBUTE + csdDFV;
};

/** @type {string} */
com.inq.flash.client.control.ClickStreamBuilder.CSDL_OS = "_OperatingSystem=OS^^OperatingSystem=";

/** @type {string} */
com.inq.flash.client.control.ClickStreamBuilder.CSDL_USERAGENT = "_UserAgent=UserAgent^^UserAgent=";

/** @type {string} */
com.inq.flash.client.control.ClickStreamBuilder.CSDL_BROWSER = "_Browser=Browser^^Browser=";

/** @type {string} */
com.inq.flash.client.control.ClickStreamBuilder.CSDL_CLICK2PER = "_ClickToPersistent=ClickToPersistent^^ClickToPersistent=";

/** @type {string} */
com.inq.flash.client.control.ClickStreamBuilder.CSDL_VISITED = "_visited=Page Markers^^visited=";

/** @type {string} */
com.inq.flash.client.control.ClickStreamBuilder.CSDL_LAUNCH_PAGE_MARKER = "_launchPageMarker=Page Marker^^launchPageMarker=";

/** @type {string} */
com.inq.flash.client.control.ClickStreamBuilder.CSDL_URL = "_URL=Page URL^^URL=";

/** @type {string} */
com.inq.flash.client.control.ClickStreamBuilder.CSDL_DFV = "_dfv=Data^^dfv=";

/** @type {string} */
com.inq.flash.client.control.ClickStreamBuilder.SEP_ATTRIBUTE = "^^";
